import { MeshBasicMaterial, Mesh } from "three";
import { VBase } from "./VBase";
import VUtil from "../VUtils";

const defaultOptions = {
  map: null,
  fillMap: null,
  opacity: 1,
  color: 0x676767,
  fillColor: 0x00ffff,
  fillOpacity: 1,
  width: 1.8,
  height: 0.05,
  radius: 0.02,
};

/*
  使用案例
  
      let bar = this.uiLib.createProgressBar();
      bar.setValue(0.5); // 设置进度值 0.0 - 1.0
      this.uiLib.addUIToScene(bar);

*/

export class VProgressBar extends VBase {
  /**
   * 创建矩形进度条
   *   options:
   * {
   *      priority: 优先级，默认为1，值越小越靠前
   *      renderOrder: 渲染顺序，默认为99998
   *      map: 进度条背景图片，默认为null，不是地址
   *      fillMap: 进度条填充图片，默认为null，不是地址
   *      color: 进度条背景色，默认为0x676767
   *      opacity: 背景透明度
   *      fillOpacity: 填充透明度
   *      fillColor: 进度条填充颜色，默认为0x00ffff
   *      width: 进度条宽度，默认为1.8
   *      height: 进度条高度，默认为0.05
   *      radius: 圆角矩形半径，默认为0.02
   * }
   * @param {*} options
   */
  constructor(options, vuiLib) {
    if (!options) options = {};

    const tempOptions = {
      renderOrder:
        options.renderOrder !== undefined ? options.renderOrder : 99998,
      priority: options.priority !== undefined ? options.priority : 1,
      map: options.map ? options.map : defaultOptions.map,
      opacity:
        options.opacity !== undefined
          ? options.opacity
          : defaultOptions.opacity,
      fillOpacity:
        options.fillOpacity !== undefined
          ? options.fillOpacity
          : defaultOptions.fillOpacity,
      fillMap: options.fillMap ? options.fillMap : defaultOptions.fillMap,
      color: options.color !== undefined ? options.color : defaultOptions.color,
      fillColor:
        options.fillColor !== undefined
          ? options.fillColor
          : defaultOptions.fillColor,
      width: options.width !== undefined ? options.width : defaultOptions.width,
      height:
        options.height !== undefined ? options.height : defaultOptions.height,
      radius:
        options.radius !== undefined ? options.radius : defaultOptions.radius,
    };

    super(tempOptions, vuiLib);
    this._vType = "VProgressBar";

    this.name = "VProgressBar";

    this._otherProps = {
      fillOpacity: tempOptions.fillOpacity,
      fillMap: tempOptions.fillMap,
      fillColor: tempOptions.fillColor,
    };

    // fill
    var vertexParsChunk = `
    #include <common>
    varying float localPosX;
  `;
    var vertexChunk = `
    #include <fog_vertex>
    localPosX = position.x;
  `;
    var fragmentParsChunk = `
            #include <common>
            uniform float limit;
            varying float localPosX;
          `;
    var diffuseColorChunk = `
              if(localPosX>limit)
              {
                discard;
              }

              vec4 diffuseColor = vec4( diffuse, opacity );
           `;
    const geo1 = VUtil.createRectangleGeometry(
      this._baseProps.width,
      this._baseProps.height,
      this._baseProps.radius
    );
    const mat1 = new MeshBasicMaterial({
      color: this._otherProps.fillColor,
      map: this._otherProps.fillMap,
      opacity: this._otherProps.fillOpacity,
      transparent: true,
      depthTest: this.depthTest,
    });
    VUtil.convertSRGBToLinear(mat1);
    mat1.userData.limit = { value: 0.5 };
    mat1.onBeforeCompile = (shader) => {
      shader.vertexShader = shader.vertexShader
        .replace("#include <common>", vertexParsChunk)
        .replace("#include <fog_vertex>", vertexChunk);

      shader.fragmentShader = shader.fragmentShader
        .replace("#include <common>", fragmentParsChunk)
        .replace(
          "vec4 diffuseColor = vec4( diffuse, opacity );",
          diffuseColorChunk
        );
      shader.uniforms.limit = mat1.userData.limit;
    };
    this.fill = new Mesh(geo1, mat1);
    this.fill.renderOrder = this._baseProps.renderOrder;
    this.add(this.fill);
  }

  /**
   * 设置进度值
   * @param {Number} value 0到1的小数值
   */
  setValue(value) {
    value = Math.max(0, Math.min(value, 1));
    const v = this._baseProps.width * value - this._baseProps.width / 2;

    this.fill.material.userData.limit.value = v;
  }

  // 此对象不需要点击交互
  getClickable() {
    return [];
  }
}
